import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from './_virtual/_rollupPluginBabelHelpers.js';
import thunkMiddleware from './node_modules/redux-thunk/es/index.js';
import auth from './modules/auth/reducers.js';
import builders from './components/builders/reducers.js';
import lookups from './modules/lookups/reducers.js';
import notifications from './modules/notifications/reducers.js';
import preferences from './modules/preferences/reducers.js';
import abortMiddleware$1 from './modules/abort/middleware.js';
import apiMiddleware$1 from './modules/api/middleware.js';
import loggingMiddleware$1 from './modules/logging/middleware.js';
import lookupMiddleware$1 from './modules/lookups/middleware.js';
import loggingEnhancer$1 from './modules/logging/enhancer.js';
import { createReduxStore } from './modules/store/config.js';

var additionalDefaultReducers = {};

var addDefaultReducers = function addDefaultReducers(reducers) {
  additionalDefaultReducers = _objectSpread2(_objectSpread2({}, additionalDefaultReducers), reducers);
};

var getDefaultReducers = function getDefaultReducers() {
  return _objectSpread2({
    auth: auth,
    builders: builders,
    lookups: lookups,
    notifications: notifications,
    preferences: preferences
  }, additionalDefaultReducers);
};

var getDefaultMiddleware = function getDefaultMiddleware() {
  return [apiMiddleware$1(), lookupMiddleware$1(), loggingMiddleware$1(), thunkMiddleware, abortMiddleware$1() // must run before thunk
  ];
};

var getDefaultEnhancers = function getDefaultEnhancers() {
  return [loggingEnhancer$1()];
};

var createDefaultReduxStore = function createDefaultReduxStore() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var reducers = _objectSpread2(_objectSpread2({}, options.reducers || {}), getDefaultReducers());

  var middleware = [].concat(_toConsumableArray(options.middleware || []), _toConsumableArray(getDefaultMiddleware()));
  var enhancers = [].concat(_toConsumableArray(options.enhancers || []), _toConsumableArray(getDefaultEnhancers()));
  return createReduxStore(_objectSpread2(_objectSpread2({}, options), {}, {
    reducers: reducers,
    middleware: middleware,
    enhancers: enhancers
  }));
};

export { addDefaultReducers, createDefaultReduxStore, getDefaultEnhancers, getDefaultMiddleware, getDefaultReducers };
